<template>
    <div class="miles-earned">
        <div class="heading">
            <h4 class="heading__h4">Statement credits earned through Beyond Ulta Beauty Rewards<sup>&#8482;</sup></h4>
        </div>
        <div class="points">
            <div class="value">{{this.user && this.user.cash_earned ? '$'+this.user.cash_earned : '$0'}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'miles-earned',
        data() {
            return{
                user: null
            }
        },
        mounted() {
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                // console.log(this.user);
            }
        }
    }
</script>

<style>

</style>
